(function () {
    "use strict";

    // @ngInject
    function EditOpportunityControllerCtor($scope, $window, $injector, $modalInstance, $translate, $timeout, OpportunityTypesService, moment, UIUtils, AnalyticsService,
                                             Enums, NetworkManager, RepositoryService, ModelFactory, $location, modalParams, GeoLocationHelper, ServiceLazyLoaderService,
                                             PopupMessageService, $q, $filter, $document, $) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'EditOpportunityController';
        this.$q = $q;
        this.$ = $;
        this.$window = $window;
        this.$modalInstance = $modalInstance;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$document = $document;
        this.currTimeout = null;
        this.moment = moment;
        this.RepositoryService = RepositoryService;
        this.ModelFactory = ModelFactory;
        this.google = ServiceLazyLoaderService.get('google');
        this.$location = $location;
        this.UIUtils = UIUtils;
        this.DistTypes = Enums.OpportunityDistributionTypes;
        this.NetworkManager = NetworkManager;
        this.$translate = $translate;
        this.GeoLocationHelper = GeoLocationHelper;
        this.selectedVendorTypes = [];
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.OpportunityTypesService = OpportunityTypesService;
        this.selectedItem = null;
        this.searchText = null;

        this.TITLE_SETTINGS = {
            MAX_LENGTH: 140,
            MAX_NEGATIVE_CHARS: 60,
            CHANGE_STYLE_AFTER_CHARS: 125,
            MIN_CHARS_TO_SHOW_COUNTER: 80
        };

        this.showAudienceEditInstructions = false;
        this.isFormValid = true;
        this.formErrors = [];

        this.vendorTypeSelectedModel = undefined;

        this.vendorTypes = Enums.SupportedCreativeTypes.map(function (item) {
            return {key: item.key, name: $translate.instant(item.translationEntry)};
        });

        this.$modalInstance.onBeforeClose = this.onBeforeCloseOpportunityEditModal.bind(this);

        $scope.$on('$destroy', function () {
            if (this.currTimeout) {
                this.$timeout.cancel(this.currTimeout);
            }
            window.onbeforeunload = null;
        }.bind(this));

        $scope.$watch('editOpportunityVm.shareIsoForm.$dirty', function(isDirtyNow, wasDirtyBefore) {
            //adding browser confirm message on before leaving the url
            window.onbeforeunload = function (e) {
                return (isDirtyNow || undefined);
            };
        });

        this.OPPORTUNITY_TYPES = OpportunityTypesService.listEdit;

        $scope.$watch('editOpportunityVm.selectedOpportunityType', function (newSelectedOpportunityType, oldSelectedOpportunityType) {
            if (newSelectedOpportunityType !== oldSelectedOpportunityType) {
                if (newSelectedOpportunityType) {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                        {
                            unique: 'select_opp_type',
                            page: 'opp_select_type',
                            opp_type : newSelectedOpportunityType
                        });

                    this.opportunityTypeItemClickHandler(newSelectedOpportunityType);
                } else {
                    this.currSelectedOpportunityObject = '';
                }
            }
        }.bind(this));

        function setDirtyIfNeed(newTitle, oldTitle) {
            if (newTitle && newTitle !== oldTitle) {
                this.shareIsoForm.$setDirty();
            }
        }

        $scope.$watch('editOpportunityVm.lookingFor', setDirtyIfNeed.bind(this));
        $scope.$watch('editOpportunityVm.description', setDirtyIfNeed.bind(this));


        // Workaround to have the modal backdrop dismissing the modal.
        // Since the overlay click event is called also on button click!
        this.$timeout(function () {
            $('.create-opportunity-modal__overlay').click(function(e) {
                if (e.currentTarget === e.target) {
                    this.dismiss();
                }
            }.bind(this));
        }.bind(this), 1000);

        this.referral = modalParams.referral;
        this.isSavingReferral = false;

        this._initFields(modalParams);
    }

    Controllers.EditOpportunityController = Class(Controllers.BaseController, {
        constructor: EditOpportunityControllerCtor,

        onBeforeCloseOpportunityEditModal: function onBeforeCloseOpportunityEditModal() {

            var deferred = this.$q.defer();
            if (this.shareIsoForm.$dirty) {
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning, 'Looks like you have unsaved changes. Your edits will be lost if you leave. Are you sure you want to discard your changes?',
                    function user_confirm_leaving_opportunity_create_modal() {
                        deferred.resolve();
                    }.bind(this),
                    function() { deferred.reject('not allowed.');}
                );
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        },

        _initFields: function _initFields(modalParams) {
            if (modalParams && modalParams.referral && modalParams.referral._id) {
                this.lookingFor = modalParams.referral.looking_for;
                this.description = modalParams.referral.description;

                this.currSelectedOpportunityObject = this.OpportunityTypesService.listEdit[modalParams.referral.opportunity_type];

                this.selectedOpportunityType = modalParams.referral.opportunity_type;

                this.maxBudget = modalParams.referral.max_budget;
                this.minBudget = modalParams.referral.min_budget;

                this.selectedVendorTypes = [];
                modalParams.referral.vendor_types.forEach(function (vendor_type) {
                    this.selectedVendorTypes.push(this.$filter('filter')(this.vendorTypes, {key: vendor_type}, true)[0]);
                }.bind(this));

                this.isoLocation = modalParams.referral.location;
                this.isoCoordinates = modalParams.referral.coordinates;
                this.distType = modalParams.referral.dist_type;

                if (this.distType !== 'anywhere') {
                    this.$timeout(function () {
                        this.initMap(this.isoCoordinates);
                    }.bind(this));
                }
            }

            this._initTitlePlaceholder();
        },

        _initTitlePlaceholder : function _initPlaceholder() {
            var now = new Date();
            var oneMonthFromNow = this.moment(now).add(1, 'M').format('MMM DD, YYYY');
            
            this.lookingForPlaceholder = this.$translate.instant('NETWORK.FEED._LOOKING_FOR_PLACEHOLDER_', {date: oneMonthFromNow});
        },

        close: function close(passedDataFromModal) {
            this.$modalInstance.close(passedDataFromModal);
        },

        dismiss: function dismiss() {
            this.$modalInstance.dismiss();
        },

        getTitleCounter: function() {
            var titleCounter = '';
            if (this.lookingFor && (this.lookingFor.length >= this.TITLE_SETTINGS.MIN_CHARS_TO_SHOW_COUNTER)) {
                titleCounter = this.TITLE_SETTINGS.MAX_LENGTH - this.lookingFor.length;
            }
            return titleCounter;
        },

        initMap: function initMap(coordinates) {
            var mapElement = document.getElementById('edit_opportunity_map');
            var centerCoordinates = {
                lng: coordinates.lon,
                lat: coordinates.lat
            };

            this.google.then(function(googleSdk) {
                var self = this;
                var map = new googleSdk.maps.Map(mapElement, {
                    zoom: 5,
                    center: centerCoordinates,
                    disableDefaultUI: true
                });

                googleSdk.maps.event.addListener(map, "tilesloaded", function () {
                    [].slice.apply(document.querySelectorAll('#edit_opportunity_map a')).forEach(function (item) {
                        item.setAttribute('tabindex', '-1');
                    });

                    self.$('#edit_opportunity_map .gm-style > div:first-child').attr('tabindex', '-1');
                });
            });
        },

        updateReferral: function updateReferral() {
            this.isSavingReferral = true;

            var referralData = {
                looking_for: this.lookingFor,
                description: this.description,
                opportunity_type: this.selectedOpportunityType
            };

            if (this.maxBudget || this.minBudget) {
                if (this.maxBudget && !this.minBudget) {
                    // little tweak to align same functionality sa the mobile-app.
                    referralData.min_budget = this.maxBudget;
                } else {
                    referralData.min_budget = this.minBudget;
                    referralData.max_budget = this.maxBudget;
                }
            }

            this.NetworkManager.updateNetworkReferral(this.referral, referralData).then(

                function success(resp) {
                    this.shareIsoForm.$setPristine();
                    this.close({status: 'ok'});
                }.bind(this),

                function error(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_referral, resp);

                    this.formErrors.push('Oops... something went wrong. Please try again');
                    this.isFormValid = false;

                }.bind(this))
                .finally(function finallyHandler() {

                    this.isSavingReferral = false;

                }.bind(this));
        },

        isTitleTooLong: function isTitleTooLong() {
            var titleCounter = this.getTitleCounter();
            return (titleCounter !== '' && titleCounter < 0);
        },

        isOppTypeInvalid: function isValidOppType() {
            return (this.selectedOpportunityType === '');
        },

        isTitleInvalid: function isTitleInvalid() {
            return (!this.lookingFor || (this.lookingFor.trim() === ''));
        },

        isBudgetInvalid : function isBudgetInvalid() {
            return (this.minBudget && this.maxBudget && (this.minBudget > this.maxBudget));
        },

        _addErrorCssClassToModal: function _addErrorCssClassToModal() {
            this.$('.create-opportunity-modal').addClass('network-feed-share__form__error-animation');
            this.currTimeout = this.$timeout(this._removeErrorCssClassFromModal, 2000);
        },

        _removeErrorCssClassFromModal: function _addErrorCssClassToModal() {
            this.$('.create-opportunity-modal').removeClass('network-feed-share__form__error-animation');
        },

        _resetErrors: function _resetErrors() {
            this._removeErrorCssClassFromModal();
            this.isFormValid = true;
        },

        getFormErrors: function getFormErrors() {
            var errors = [];

            if (this.isOppTypeInvalid()) {
                errors.push('Please select an opportunity type');
            }

            if (this.isTitleInvalid()) {
                errors.push('Please add a title in order to post');
            }

            if (this.selectedOpportunityType === this.OPPORTUNITY_TYPES.paid_opportunity.key && this.isBudgetInvalid()) {
                errors.push('Budget maximum should be higher than minimum');
            }

            if (this.isTitleTooLong()) {
                errors.push('Title should have a max of 140 chars');
            }

            return errors;
        },

        isFormFieldsValid: function isFormFieldsValid() {
            this.formErrors = this.getFormErrors();
            return this.formErrors.length === 0;
        },

        handleClickSaveChanges: function handleClickSaveChanges() {
            if (this.isFormFieldsValid()) {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                    unique: 'update_opportunity'
                });

                this._resetErrors();
                this.shareIsoForm.$setSubmitted();

                this.updateReferral();
            } else {
                this.showAudienceEditInstructions = false;
                this.isFormValid = false;
                this._addErrorCssClassToModal();
            }
        },

        handleClickCreateOpportunity: function handleClickCreateOpportunity() {
            this.close({status: 'create_new'});
        },

        inputAllowNumbersOnly: function inputAllowNumbersOnly(e) {
            var keyCode = (e.keyCode ? e.keyCode : e.which);
            if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
                e.preventDefault();
            }
        },

        opportunityTypeItemClickHandler: function(opportunity_type_key) {
            this.formErrors = this.getFormErrors();
            this.currSelectedOpportunityObject = this.OPPORTUNITY_TYPES[opportunity_type_key];
            this.shareIsoForm.$setDirty();
        },

        handleClickAudienceDisabled: function handleClickAudienceDisabled() {
            this.showAudienceEditInstructions = true;
        },
    });
}());
